import * as React from 'react';
import isNativeModuleSwitcherEnabled from '../utils/isNativeModuleSwitcherEnabled';
import MiniModuleSwitcher from './MiniModuleSwitcher';
import type ModuleSwitcherProps from './ModuleSwitcherProps';
import NativeModuleSwitcher from './NativeModuleSwitcher';
import { observer } from 'mobx-react';

export default observer(function ModuleSwitcher(props: ModuleSwitcherProps) {
    if (isNativeModuleSwitcherEnabled()) {
        return <NativeModuleSwitcher {...props} />;
    } else {
        return <MiniModuleSwitcher {...props} />;
    }
});
